import gql from 'graphql-tag';

const MEMBER_LICENSES_TABLE = gql`
query memberLicensesTable($offset: Int, $limit: Int, $sort: [MemberLicensesTableSortInput!], $filter: [MemberLicensesTableFilterInput]) {
    memberLicensesTable(offset: $offset, limit: $limit, sort: $sort, filter: $filter) {
        totalCount
        items {
            id
            year
            uciId
            member
            club
            function
            categories
            revokedAt
        }
    }
}
`;

export default MEMBER_LICENSES_TABLE;